<template>
    <CompassDialog
        class="import-old-note__wrapper"
        :visible.sync="isVisible"
        size="medium"
        :title="$t.__('popups.overviews.ImportOldOppOverviewNote.merge_informations')"
        body-scroll
        :close-on-click-overlay="false"
        @closed="close"
    >
        <template #defalt>
            <div>
                <CompassAlert
                    type="informative"
                    :show-close="false"
                    :description="alertInfoContent"
                >
                </CompassAlert>

                <div>
                    <p class="bold fs-3 lh-20 mt-0 mb-2">
                        {{ $l10n.__('Ancienne donnée de la note') }}
                    </p>
                    <p class="fs-3 lh-20 m-0" v-html="oldNoteValue"></p>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="flex-row pb-5 px-5 pt-4 import-old-note__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="close"
                />
                <CompassButton
                    :label="$t.__('popups.overviews.ImportOldOppOverviewNote.import_in_comment')"
                    left-icon="download"
                    class="ml-3"
                    @click="importOldNote"
                />
            </div>
        </template>
    </CompassDialog>
</template>

<script>
export default {
    props: {
        oldNoteValue: {
            type: String,
            required: false,
            default: '',
        },
    },
    data() {
        return { isVisible: true };
    },
    computed: {
        alertInfoContent() {
            return this.$l10n.__(
                'Nous avons détecté des données dans l’ancien champ Note de cette opportunité.\n\
                Nous travaillons à simplifier et rassembler toutes vos informations notes et briefs au même \n\
                endroit. Nous vous proposons de basculer automatiquement ce contenu dans votre nouveau \n\
                champ Note.',
            );
        },
    },
    methods: {
        importOldNote() {
            EventBus.emit('overview:importOldNote');
        },
        close() {
            EventBus.emit('overview:closeDialog');
        },
    },
};
</script>

<style lang="scss" scoped>
.import-old-note__wrapper {
    &::v-deep .compass-alert__text-container {
        white-space: pre-line;
    }
    .import-old-note__footer {
        justify-content: end;
    }
    &::v-deep {
        .alert {
            padding: 16px 18px;
            .el-alert__content {
                padding: 0;
                .el-alert__description {
                    margin: 0;
                    display: flex;
                    .compass-icon {
                        min-width: 20px;
                        display: inline;
                        margin-right: 10px;
                    }
                }
            }
        }
    }
}
</style>
